var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHosting2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 56 48",
    width: 56,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 35.59C1.28 34.57 1.61 33.58 2 32.61C2 31.17 2 23.97 2 11L54 11C54 23.97 54 31.17 54 32.61C54.39 33.58 54.72 34.57 55 35.59C55 33.28 55 21.75 55 1L1 1C1 21.75 1 33.28 1 35.59ZM2 10L2 2L54 2L54 10L2 10Z",
    id: "bcvjJolNe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L5 7L5 5L7 5L7 5L7 7ZM7 4L5 4L4 4L4 5L4 7L4 8L5 8L7 8L8 8L8 7L8 5L8 4L8 4L7 4Z",
    id: "evEpOh9nY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 45L5 46C16.41 46 22.75 46 24.02 46C23.79 45.69 23.58 45.36 23.42 45C20.97 45 14.83 45 5 45Z",
    id: "b59HT80HI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.98 46C33.24 46 39.59 46 51 46L51 45L32.58 45C32.33 45.46 32.13 45.79 31.98 46Z",
    id: "a28l9seERX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 42.5C10 42.5 10 42.5 10 42.5C10 43.1 10 43.43 10 43.5C10 43.5 10 43.5 10 43.5C7.6 43.5 6.27 43.5 6 43.5C6 43.5 6 43.5 6 43.5C6 42.9 6 42.57 6 42.5C6 42.5 6 42.5 6 42.5C8.4 42.5 9.73 42.5 10 42.5Z",
    id: "c2TUTBgnd4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 7L38 7L38 5L51 5L51 5L51 7ZM51 4L38 4L37 4L37 5L37 7L37 8L38 8L51 8L52 8L52 7L52 5L52 4L52 4L51 4Z",
    id: "euGjs1hAn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7L17 7L17 5L19 5L19 5L19 7ZM19 4L17 4L16 4L16 5L16 7L16 8L17 8L19 8L20 8L20 7L20 5L20 4L20 4L19 4Z",
    id: "d7h2Vq08ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7L11 7L11 5L13 5L13 5L13 7ZM13 4L11 4L10 4L10 5L10 7L10 8L11 8L13 8L14 8L14 7L14 5L14 4L14 4L13 4Z",
    id: "b4bO51pC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 38.77C10.5 38.77 10.5 38.77 10.5 38.77C10.37 39.36 10.3 39.68 10.29 39.75C10.29 39.75 10.29 39.75 10.29 39.75C7.94 39.25 6.64 38.97 6.38 38.92C6.38 38.92 6.38 38.92 6.38 38.92C6.5 38.33 6.57 38 6.58 37.94C6.58 37.94 6.58 37.94 6.58 37.94C8.93 38.44 10.24 38.71 10.5 38.77Z",
    id: "bBJcLBpze"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 35.22C11.76 35.22 11.76 35.22 11.76 35.22C11.52 35.77 11.38 36.07 11.35 36.13C11.35 36.13 11.35 36.13 11.35 36.13C9.16 35.16 7.94 34.62 7.7 34.51C7.7 34.51 7.7 34.51 7.7 34.51C7.94 33.96 8.08 33.65 8.11 33.59C8.11 33.59 8.11 33.59 8.11 33.59C10.3 34.57 11.52 35.11 11.76 35.22Z",
    id: "a4nqzykBdG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 32.01C13.73 32.01 13.73 32.01 13.73 32.01C13.38 32.5 13.18 32.77 13.14 32.82C13.14 32.82 13.14 32.82 13.14 32.82C11.2 31.41 10.12 30.63 9.91 30.47C9.91 30.47 9.91 30.47 9.91 30.47C10.26 29.99 10.46 29.72 10.5 29.66C10.5 29.66 10.5 29.66 10.5 29.66C12.44 31.07 13.52 31.86 13.73 32.01Z",
    id: "k1xZbb4pRE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.33 29.29C16.33 29.29 16.33 29.29 16.33 29.29C15.88 29.69 15.64 29.91 15.59 29.96C15.59 29.96 15.59 29.96 15.59 29.96C13.98 28.18 13.09 27.18 12.91 26.99C12.91 26.99 12.91 26.99 12.91 26.99C13.36 26.58 13.6 26.36 13.65 26.32C13.65 26.32 13.65 26.32 13.65 26.32C15.26 28.1 16.15 29.09 16.33 29.29Z",
    id: "a2RFLnzyKo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.43 27.16C19.43 27.16 19.43 27.16 19.43 27.16C18.91 27.46 18.63 27.63 18.57 27.66C18.57 27.66 18.57 27.66 18.57 27.66C17.37 25.58 16.7 24.43 16.57 24.2C16.57 24.2 16.57 24.2 16.57 24.2C17.09 23.9 17.37 23.73 17.43 23.7C17.43 23.7 17.43 23.7 17.43 23.7C18.63 25.77 19.3 26.93 19.43 27.16Z",
    id: "aSkszewtw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.91 25.73C22.91 25.73 22.91 25.73 22.91 25.73C22.34 25.91 22.03 26.01 21.96 26.03C21.96 26.03 21.96 26.03 21.96 26.03C21.22 23.75 20.81 22.49 20.73 22.23C20.73 22.23 20.73 22.23 20.73 22.23C21.3 22.05 21.61 21.94 21.68 21.92C21.68 21.92 21.68 21.92 21.68 21.92C22.42 24.2 22.83 25.47 22.91 25.73Z",
    id: "aafk50HaL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.62 25.05C26.62 25.05 26.62 25.05 26.62 25.05C26.02 25.11 25.69 25.14 25.62 25.15C25.62 25.15 25.62 25.15 25.62 25.15C25.37 22.76 25.23 21.44 25.2 21.17C25.2 21.17 25.2 21.17 25.2 21.17C25.8 21.11 26.13 21.08 26.2 21.07C26.2 21.07 26.2 21.07 26.2 21.07C26.45 23.45 26.59 24.78 26.62 25.05Z",
    id: "bq0QL6EfC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.38 25.15C30.38 25.15 30.38 25.15 30.38 25.15C29.79 25.09 29.45 25.05 29.39 25.05C29.39 25.05 29.39 25.05 29.39 25.05C29.64 22.66 29.78 21.34 29.8 21.07C29.8 21.07 29.8 21.07 29.8 21.07C30.4 21.13 30.73 21.17 30.8 21.17C30.8 21.17 30.8 21.17 30.8 21.17C30.55 23.56 30.41 24.89 30.38 25.15Z",
    id: "cMdyIx9jZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.04 26.03C34.04 26.03 34.04 26.03 34.04 26.03C33.47 25.85 33.15 25.74 33.09 25.72C33.09 25.72 33.09 25.72 33.09 25.72C33.83 23.44 34.24 22.17 34.32 21.92C34.32 21.92 34.32 21.92 34.32 21.92C34.89 22.11 35.21 22.21 35.27 22.23C35.27 22.23 35.27 22.23 35.27 22.23C34.53 24.51 34.12 25.78 34.04 26.03Z",
    id: "aoFqpg0Uy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.57 23.7L39.43 24.2L37.44 27.66L36.57 27.16L38.57 23.7Z",
    id: "a3uETSO7Si"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42 29.96C40.42 29.96 40.42 29.96 40.42 29.96C39.97 29.56 39.72 29.33 39.67 29.29C39.67 29.29 39.67 29.29 39.67 29.29C41.28 27.51 42.17 26.52 42.35 26.32C42.35 26.32 42.35 26.32 42.35 26.32C42.79 26.72 43.04 26.94 43.09 26.99C43.09 26.99 43.09 26.99 43.09 26.99C41.49 28.77 40.6 29.76 40.42 29.96Z",
    id: "btmlZQNc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.41 39.06C25.48 39.35 24 40.99 24 43C24 45.21 25.79 47 28 47C30.01 47 31.65 45.52 31.94 43.59C32.54 42.68 35.56 38.15 41 30C32.85 35.44 28.32 38.46 27.41 39.06ZM29.06 39.16C29.62 38.79 32.4 36.94 37.4 33.61L31.84 41.94C30.89 40.34 29.96 39.41 29.06 39.16ZM25 43C25 41.91 25.58 40.97 26.45 40.44C26.64 40.33 26.84 40.24 27.06 40.17C27.07 40.16 27.08 40.16 27.09 40.15C27.31 40.09 27.53 40.04 27.77 40.02C27.85 40.02 27.92 40 28 40C29.66 40 31 41.34 31 43C31 43.08 30.98 43.16 30.98 43.23C30.96 43.47 30.91 43.69 30.85 43.91C30.84 43.92 30.84 43.93 30.83 43.94C30.76 44.16 30.67 44.36 30.55 44.55C30.03 45.42 29.09 46 28 46C26.34 46 25 44.66 25 43Z",
    id: "aXXQsjT7p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 43C5 30.32 15.32 20 28 20C40.68 20 51 30.32 51 43C51 44.02 50.93 45.02 50.8 46C50.9 46 51.71 46 51.81 46C51.93 45.02 52 44.02 52 43C52 29.75 41.25 19 28 19C14.75 19 4 29.75 4 43C4 44.02 4.07 45.02 4.19 46C4.26 46 4.6 46 5.2 46C5.07 44.68 5 43.68 5 43Z",
    id: "bFLKCaBu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 43C2 28.66 13.66 17 28 17C42.34 17 54 28.66 54 43C54 44.02 53.94 45.02 53.82 46C53.92 46 54.73 46 54.83 46C54.94 45.02 55 44.02 55 43C55 28.09 42.91 16 28 16C13.09 16 1 28.09 1 43C1 44.02 1.06 45.02 1.17 46C1.24 46 1.57 46 2.18 46C2.06 44.68 2 43.68 2 43Z",
    id: "aWIbfixqm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86 32.83C42.86 32.83 42.86 32.83 42.86 32.83C42.51 32.34 42.31 32.07 42.27 32.02C42.27 32.02 42.27 32.02 42.27 32.02C44.21 30.61 45.29 29.82 45.51 29.67C45.51 29.67 45.51 29.67 45.51 29.67C45.86 30.15 46.06 30.42 46.1 30.48C46.1 30.48 46.1 30.48 46.1 30.48C44.16 31.89 43.08 32.67 42.86 32.83Z",
    id: "e2pc3wkkpO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9 33.59L48.3 34.51L44.65 36.14L44.25 35.22L47.9 33.59Z",
    id: "dqU2Gknpj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.42 37.94L49.63 38.92L45.71 39.75L45.51 38.77L49.42 37.94Z",
    id: "b33SNF0FP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 42.5C50 42.5 50 42.5 50 42.5C50 43.1 50 43.43 50 43.5C50 43.5 50 43.5 50 43.5C47.6 43.5 46.27 43.5 46.01 43.5C46.01 43.5 46.01 43.5 46.01 43.5C46.01 42.9 46.01 42.57 46.01 42.5C46.01 42.5 46.01 42.5 46.01 42.5C48.4 42.5 49.74 42.5 50 42.5Z",
    id: "e1zB0Olisr"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcvjJolNe",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcvjJolNe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#evEpOh9nY",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#evEpOh9nY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b59HT80HI",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b59HT80HI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a28l9seERX",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a28l9seERX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2TUTBgnd4",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2TUTBgnd4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#euGjs1hAn",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#euGjs1hAn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d7h2Vq08ac",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d7h2Vq08ac",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4bO51pC6",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4bO51pC6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bBJcLBpze",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bBJcLBpze",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4nqzykBdG",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4nqzykBdG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1xZbb4pRE",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1xZbb4pRE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2RFLnzyKo",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2RFLnzyKo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aSkszewtw",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aSkszewtw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aafk50HaL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aafk50HaL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bq0QL6EfC",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bq0QL6EfC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cMdyIx9jZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cMdyIx9jZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoFqpg0Uy",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoFqpg0Uy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3uETSO7Si",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3uETSO7Si",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btmlZQNc",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btmlZQNc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aXXQsjT7p",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aXXQsjT7p",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bFLKCaBu",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bFLKCaBu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aWIbfixqm",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aWIbfixqm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2pc3wkkpO",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2pc3wkkpO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dqU2Gknpj",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dqU2Gknpj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b33SNF0FP",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b33SNF0FP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1zB0Olisr",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1zB0Olisr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting2);
export default __webpack_public_path__ + "static/media/hosting-2.25cad95919fd35124ab217939095f11a.svg";
export { ForwardRef as ReactComponent };